
import React, { useEffect, useState } from "react"
import { Picker, Button, Space } from 'antd-mobile-v5';
import { Toast } from 'antd-mobile';
import styles from "./calendar.module.scss";
import dayjs from 'dayjs';
import dateUtil from '../../utils/date'
import { ApiCore } from '../../api';
import calendar_icon from '../../static/images_ae/calendar_icon_blue.png'; // calendar_icon
import utils from "../../utils/utils";
const api = new ApiCore();

const Calendar = (props: any) => {

    const [currentMonth, setCurrentMonth] = useState(dayjs(new Date()).format('YYYY-MM')) //当前月份 日期格式 2022-03
    const [currentDay, setCurrentDay] = useState(dayjs(new Date()).format('YYYY-MM-DD'))
    const [monthList, setMonthList] = useState<Array<string>>([])
    const [isThisYearMonth, setIsThisYearMonth] = useState(true);
    const [thisDate, setThisDate] = useState<any>(null);

    const [currenrYear, setCurrenrYear] = useState<any>([(new Date().getFullYear())])
    const [yearColumns, setYearColumns] = useState<any>([])
    const [visible, setVisible] = useState(false)

    const [weekList, setWeekList] = useState([
        { name: '周日', className: '' },
        { name: '周一', className: '' },
        { name: '周二', className: '' },
        { name: '周三', className: '' },
        { name: '周四', className: '' },
        { name: '周五', className: '' },
        { name: '周六', className: '' }
    ])

    const [dayList, setDayList] = useState<any>([])
    const [isTodaySigned, setIsTodaySigned] = useState<any>(null)
    const [count, setCount] = useState<any>(null)


    useEffect(() => {

        document.title = '每日签到';

        initConditions();

        initYearColumns();

        initMonth(currentMonth)

        initCalendar(currentMonth)

    }, [])

    const initConditions = () => {
        const urlParams = utils.getUrlParams();
        const _isTodaySigned = (urlParams.isTodaySigned == 'true');
        if (urlParams.needHomeInfo == 'true') {
            initHomeInfo();
        } else {
            setIsTodaySigned(_isTodaySigned);
            setCount(urlParams.count);
        }
    }

    const initHomeInfo = () => {
        api.getSignInHome().then((res: any) => {
            if (res.code == 0) {
                const _items = res.data?.items || [];
                const isTodaySigned = _items.some((v: any) => {
                    if (v.todayflag && v.signFlag) {
                        return true;
                    } else {
                        return false;
                    }
                });
                setIsTodaySigned(isTodaySigned);
                setCount(res.data?.count);
            }
        });
    }

    const initYearColumns = () => {
        const _arr = [];
        const _thisYear = (new Date().getFullYear());
        for (let index = _thisYear; index > 1990; index--) {
            _arr.push({
                label: index + '', value: index + ''
            });
        } 
        setYearColumns([_arr]);
    }

    /**
     * 初始化月份
     * @param monthString  月份 例如：2022-03
     */
    const initMonth = (monthString: any) => {
        let monthList: any = [];

        let year = new Date(monthString).getFullYear()

        let date1 = new Date(monthString);
        let backMonthArr: any = [];

        date1.setMonth(date1.getMonth() - 1, 1) //获取到当前月份,设置月份
        for (let i = 0; i < 4; i++) {
            date1.setMonth(date1.getMonth() + 1); //每次循环一次 月份值加1
            let m: any = date1.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            backMonthArr.push({
                name: year + "-" + m,
                count: 0
            })
        }

        let date = new Date(monthString);
        let forentMonthArr: any = [];

        date.setMonth(date.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (let i = 0; i < 4; i++) {
            date.setMonth(date.getMonth() - 1);//每次循环一次 月份值减1
            let m: any = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            forentMonthArr.push({
                name: year + "-" + m,
                count: 0
            })
        }
        forentMonthArr = forentMonthArr.reverse().splice(0, 3)
        monthList = [...forentMonthArr, ...backMonthArr]
        setMonthList(monthList)
    }


    /**
     * 初始化日历
     * @param monthString  月份 例如：2022-03
     */
    const initCalendar = (monthString: any) => {
        let _year = new Date(monthString).getFullYear()
        let _month = new Date(monthString).getMonth() + 1;
        let _date = (new Date()).getDate();
        let _thisYear = new Date().getFullYear();
        let _thisMonth = new Date().getMonth() + 1;

        setThisDate(_date);
        setIsThisYearMonth((_thisYear == _year) && (_thisMonth == _month));

        //dayCount 一月的总天数  firstDay本月第一天是周几
        let firstDay: any = dateUtil.firstDayOfMonth(monthString);
        let dayCount: any = dateUtil.getDaysInMonth(_year, _month);
        let dayList: any = []

        for (let index = 0; index < dayCount; index++) {
            let dayStr = (index + 1) < 10 ? '0' + (index + 1) : index + 1; //返回的是当天几号  01 02 03
            let dateStr = `${monthString}-${dayStr}`; //返回的是当天日期  2022-02-22

            let count = 0;
            dayList.push({
                name: index + 1, date: dateStr, count: count
            })
        }
        for (let index = 0; index < firstDay; index++) {
            dayList.unshift({ name: '', date: '', count: 0 })
        }
        // 补全缺口
        // while (dayList.length % 7 == 0) {
        //     dayList.push({ name: '', date: '', count: 0 })
        // }
        setDayList(dayList);
        const _param = {
            year: _year,
            month: _month,
        };
        api.getSignInCalendar(_param).then((res: any) => {
            if (res.code == 0) {
                const _data = res.data;
                setCount(_data.count);
                setIsTodaySigned(_data.todaySignFlag);
                let __dayList = dayList;
                // 签名高亮
                (res.data?.records || []).forEach((item: any, index: number) => {
                    __dayList = __dayList.map((val: any) => {
                        const isSigned = val.name == item;
                        if (isSigned) {
                            return {
                                ...val,
                                isSigned: isSigned
                            }
                        } else {
                            return val;
                        }
                    })
                })
                // 今天高亮
                __dayList = __dayList.map((val: any) => {
                    let isToday = false;
                    if (((val.name == _date) && (_thisYear == _year) && (_thisMonth == _month))) {
                        isToday = true;
                    }
                    return {
                        isToday,
                        ...val
                    }
                })
                setDayList(__dayList);
            }
        });
    }

    //切换年份
    const changeYear = (year: any) => {
        let _year = year.toString()

        let monthNum = new Date(currentMonth).getMonth() + 1 < 10 ? '0' + (new Date(currentMonth).getMonth() + 1) : new Date(currentMonth).getMonth() + 1
        let month = _year + '-' + monthNum

        //切换年份默认选择1号
        let defaultDay = _year + '-' + monthNum + '-01'

        setCurrentMonth(month)
        initMonth(month)
        initCalendar(month)
        setCurrentDay(defaultDay)

    }

    //切换月份
    const changeMonth = (month: string) => {
        setCurrentMonth(month)
        initMonth(month)
        initCalendar(month)
    }


    //切换当天
    const changDay = (day: string) => {
        setCurrentDay(day)
    }

    const toSign = () => {
        api.toSignInRecord().then((res: any) => {
            if (res.code == 0) {
                Toast.info('签到成功', 0.8);
                setIsTodaySigned(true);
                setCount(parseInt(count) + 1);
                initMonth(currentMonth);
                initCalendar(currentMonth);
            } else {
                Toast.info(res.message || '签到失败，请稍后再试', 0.8);
            }
        });
    }
    return (
        <div className={styles.ae_calendar}>
                <div className={styles.head}>
                    <div className={styles.head_left}>
                        {/* <div className={styles.title}>可用积分</div> */}
                        {/* <div className={styles.desc}>33</div> */}
                        {
                            count > 0 && 
                            <div className={styles.continuous}>已连签{count}天，请继续坚持哦</div>
                        }
                        {
                            count == 0 &&
                            <div className={styles.continuous}>今日还未签到，记得签到哦</div>
                        }
                    </div>
                    <div className={styles.head_right}>
                        <img src={calendar_icon} alt="" />
                    </div>
                </div>
                <div className={styles.sign_in_btn_wrap} style={{opacity: isTodaySigned === null ? '0' : '1'}}  >
                    <Button className={styles.sign_in_btn} onClick={() => { toSign() }} disabled={isTodaySigned} color="primary">{isTodaySigned ? '已签到' : '立即签到'}</Button>
                </div>
                <div className={styles.year}>
                    <div className={styles.yearName}>
                        <span onClick={() => { setVisible(true) }}>{currenrYear.toString()}</span>
                        <span onClick={() => { setVisible(true) }} className={styles.icon}></span>
                    </div>
                    <Picker
                        columns={yearColumns}
                        visible={visible}
                        onClose={() => { setVisible(false) }}
                        value={currenrYear}
                        onConfirm={v => { setCurrenrYear(v); changeYear(v) }}
                    />
                </div>

                <div className={styles.calendar}>
                    <div className={styles.monthList}>
                        {
                            monthList.map((v: any, i: number) => (
                                <div
                                    className={v.name === currentMonth ? `${styles.month} ${styles.currentMonth}` : styles.month}
                                    key={i}
                                    onClick={() => changeMonth(v.name)}
                                >
                                    <div className={styles.monthName}>
                                        {dateUtil.monthConversion(new Date(v.name).getMonth() + 1)}月
                                    </div>
                                    <div className={styles.record_num} hidden={v.count === 0}>{v.count}</div>
                                </div>
                            ))
                        }
                    </div>
                    <div className={styles.weekList}>
                        {
                            weekList.map((v: any, i: number) => (
                                <div className={styles.week} key={i}>{v.name}</div>
                            ))
                        }
                    </div>

                    <div className={styles.dayList}>
                        {
                            dayList.map((v: any, i: number) => (
                                <div
                                    className={v.date !== currentDay ? `${styles.day} ${styles.currentDay}` : styles.day}
                                    key={i}
                                    onClick={() => changDay(v.date)}
                                >
                                    <div className={`${v.isSigned ? styles.signed_in : styles.signed_in_not} ${(isThisYearMonth && (thisDate <= v.name)) ? '' : styles.no_Num}`}>{v.name}</div>
                                    <div className={`${styles.current} ${v.count > 0 ? styles.record_num : styles.no_record_num}`}>
                                        {
                                            v.isToday ?
                                            <div className={`${styles.dot}`}></div>
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
        </div>
    )
}

export default Calendar